// extracted by mini-css-extract-plugin
export default {"box":"Checkbox_box__fslZZ","wrapper":"Checkbox_wrapper__njnAL","input":"Checkbox_input__NdSAl","icon":"Checkbox_icon__nkGfq","true":"Checkbox_true__nmDTv"};